import React from 'react'
import { Modal } from '../Modal'
import { ModalBody } from '../Modal/ModalBody'
import { ModalFooter } from '../Modal/ModalFooter'
import { MediaGalleryModalBody } from './MediaGalleryModalBody'
import { MediaGalleryModalFooter } from './MediaGalleryModalFooter'
import { MediaGalleryModalHeader } from './MediaGalleryModalHeader'

export interface MediaGalleryItem {
  id: string
  url?: string
  createdAt?: string
}

interface MediaGalleryModalProps {
  show: boolean
  close: () => void
  media: MediaGalleryItem[]
  mediaGalleryIndex?: number
  setMediaGalleryIndex?: React.Dispatch<React.SetStateAction<number>>
}

export const MediaGalleryModal = ({
  show,
  close,
  media,
  mediaGalleryIndex = 0,
  setMediaGalleryIndex,
}: MediaGalleryModalProps): JSX.Element => {
  const selectedMedia = media[mediaGalleryIndex]

  return (
    <Modal show={show} size="xl">
      {{
        header: (
          <MediaGalleryModalHeader
            onClose={close}
            mediaCount={media.length}
            mediaGalleryIndex={mediaGalleryIndex}
            createdAt={selectedMedia?.createdAt}
          />
        ),
        body: (
          <ModalBody
            className="relative h-[900px] overflow-y-auto"
            padding={false}
            gap={false}
          >
            <MediaGalleryModalBody
              url={selectedMedia?.url}
              mediaLength={media.length}
              mediaGalleryIndex={mediaGalleryIndex}
              setMediaGalleryIndex={setMediaGalleryIndex}
            />
          </ModalBody>
        ),
        footer: (
          <ModalFooter>
            <MediaGalleryModalFooter mediaId={selectedMedia?.id} />
          </ModalFooter>
        ),
      }}
    </Modal>
  )
}
